(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('company-payment-log', {
                parent: 'entity',
                url: '/company-payment-log?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.companyPaymentLog.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-payment-log/company-payment-logs.html',
                        controller: 'CompanyPaymentLogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('accountClearingRequestStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('company-payment-log-detail', {
                parent: 'entity',
                url: '/company-payment-log/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.companyPaymentLog.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-payment-log/company-payment-log-detail.html',
                        controller: 'CompanyPaymentLogDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('accountClearingRequestStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'CompanyPaymentLog', function ($stateParams, CompanyPaymentLog) {
                        return CompanyPaymentLog.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('company-payment-log.new', {
                parent: 'company-payment-log',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-payment-log/company-payment-log-dialog.html',
                        controller: 'CompanyPaymentLogDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    createDate: null,
                                    paymentAmount: null,
                                    wageFeeAmount: null,
                                    status: null,
                                    description: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('company-payment-log', null, {reload: true});
                    }, function () {
                        $state.go('company-payment-log');
                    });
                }]
            })
            .state('company-payment-log.edit', {
                parent: 'company-payment-log',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-payment-log/company-payment-log-dialog.html',
                        controller: 'CompanyPaymentLogDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['CompanyPaymentLog', function (CompanyPaymentLog) {
                                return CompanyPaymentLog.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('company-payment-log', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('company-payment-log.delete', {
                parent: 'company-payment-log',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-payment-log/company-payment-log-delete-dialog.html',
                        controller: 'CompanyPaymentLogDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['CompanyPaymentLog', function (CompanyPaymentLog) {
                                return CompanyPaymentLog.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('company-payment-log', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
